import React from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";

import pic1 from "../images/brands/picture1.png";
import pic2 from "../images/brands/Picture2.png";
import pic3 from "../images/brands/Picture3.png";
import pic4 from "../images/brands/Picture4.png";
import pic5 from "../images/brands/Picture5.png";
import pic6 from "../images/brands/Picture6.png";
import pic7 from "../images/brands/Picture7.png";
import pic8 from "../images/brands/Picture8.png";
import pic9 from "../images/brands/Picture9.png";
import pic10 from "../images/brands/Picture10.png";
import pic11 from "../images/brands/Picture11.png";
import pic12 from "../images/brands/Picture12.png";
import pic13 from "../images/brands/Picture13.png";
import pic14 from "../images/brands/Picture14.png";
import pic15 from "../images/brands/Picture15.png";
import pic16 from "../images/brands/Picture16.png";
import pic17 from "../images/brands/Picture17.png";
import pic18 from "../images/brands/Picture18.png";
import pic19 from "../images/brands/Picture19.png";
import pic20 from "../images/brands/Picture20.png";
import pic21 from "../images/brands/Picture21.jpg";
import pic22 from "../images/brands/Picture22.jpg";
import pic23 from "../images/brands/Picture23.png";
import pic24 from "../images/brands/Picture24.png";
import pic25 from "../images/brands/Picture25.png";
import pic26 from "../images/brands/Picture26.png";
import pic27 from "../images/brands/Picture27.png";
import pic28 from "../images/brands/Picture28.png";

const logosRow1 = [
  pic1, pic2, pic3, pic4, pic5, pic6, pic7,
  pic8, pic9, pic10, pic11, pic12, pic13, pic14
];

const logosRow2 = [
  pic15, pic16, pic17, pic18, pic19, pic20, pic21,
  pic22, pic23, pic24, pic25, pic26, pic27, pic28
];

export default function CorporateClientsSlider() {
  return (
    <section className="relative bg-gradient-to-br from-red-800 via-red-700 to-red-900 py-20 overflow-hidden w-full">

      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-80 h-80 bg-red-600/20 rounded-full blur-3xl animate-pulse" />
        <div className="absolute -bottom-40 -right-40 w-80 h-80 bg-red-500/20 rounded-full blur-3xl animate-pulse delay-1000" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/5 rounded-full blur-3xl animate-pulse delay-500" />
        <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.1)_1px,transparent_1px)] bg-[size:50px_50px]" />
      </div>

      {/* Container */}
      <div className="relative w-full mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-[95vw] xl:max-w-[90vw] 2xl:max-w-[85vw] overflow-hidden">

        {/* Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6"
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <div className="w-2 h-2 bg-red-300 rounded-full animate-pulse" />
            <span className="text-red-200 text-sm font-medium tracking-wider">
              TRUSTED CLIENTS
            </span>
          </motion.div>

          <motion.h2
            className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.7 }}
          >
            Our <span className="text-red-200">Valued</span>
            <br />
            <span className="bg-gradient-to-r from-white to-red-100 bg-clip-text text-transparent">
              Corporate Clients
            </span>
          </motion.h2>

          <motion.p
            className="text-xl text-red-100/90 max-w-2xl mx-auto leading-relaxed font-light"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.6 }}
          >
            Proudly serving Pakistan’s leading organizations — delivering{" "}
            <span className="text-white font-semibold">reliability, excellence,</span>{" "}
            and <span className="text-white font-semibold">commitment</span> across industries.
          </motion.p>
        </motion.div>

        {/* Row 1 - Seamless */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="overflow-hidden"
        >
          <Marquee gradient={false} speed={40} pauseOnHover={true}>
            {[...logosRow1, ...logosRow1].map((logo, i) => (
              <motion.div
                key={i}
                className="flex items-center justify-center mx-4 group cursor-pointer"
                whileHover={{ scale: 1.05, y: -5 }}
              >
                <div className="relative">
                  <div className="absolute inset-0 bg-red-400/10 blur-xl group-hover:blur-2xl rounded-2xl scale-110 opacity-0 group-hover:opacity-100 transition-all duration-500" />
                  <div className="relative bg-white rounded-xl p-4 shadow-xl border border-gray-100 hover:border-gray-300 transition-all duration-500 group-hover:shadow-red-500/20">
                    <img
                      src={logo}
                      alt={`Client logo ${i}`}
                      className="h-10 md:h-14 lg:h-16 w-auto object-contain transition-all duration-500 filter group-hover:brightness-110 max-w-[140px]"
                      loading="lazy"
                      onError={(e) => (e.target.style.display = 'none')}
                    />
                  </div>
                </div>
              </motion.div>
            ))}
          </Marquee>
        </motion.div>

        {/* Row 2 - Reverse Seamless */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="overflow-hidden mt-10"
        >
          <Marquee gradient={false} speed={40} direction="right" pauseOnHover={true}>
            {[...logosRow2, ...logosRow2].map((logo, i) => (
              <motion.div
                key={i}
                className="flex items-center justify-center mx-4 group cursor-pointer"
                whileHover={{ scale: 1.05, y: -5 }}
              >
                <div className="relative">
                  <div className="absolute inset-0 bg-red-400/10 blur-xl group-hover:blur-2xl rounded-2xl scale-110 opacity-0 group-hover:opacity-100 transition-all duration-500" />
                  <div className="relative bg-white rounded-xl p-4 shadow-xl border border-gray-100 hover:border-gray-300 transition-all duration-500 group-hover:shadow-red-500/20">
                    <img
                      src={logo}
                      alt={`Client logo ${i}`}
                      className="h-10 md:h-14 lg:h-16 w-auto object-contain transition-all duration-500 filter group-hover:brightness-110 max-w-[140px]"
                      loading="lazy"
                      onError={(e) => (e.target.style.display = 'none')}
                    />
                  </div>
                </div>
              </motion.div>
            ))}
          </Marquee>
        </motion.div>

        {/* Stats Section */}
        <motion.div
          className="mt-16 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          {[
            { number: "600+", label: "Clients" },
            { number: "45+", label: "Industries" },
            { number: "99%", label: "Satisfaction" },
            { number: "24/7", label: "Support" },
          ].map((stat, index) => (
            <motion.div
              key={index}
              className="text-center p-3 md:p-4 rounded-2xl bg-white/10 backdrop-blur-sm border border-white/10 hover:border-white/20 transition-all duration-500"
              whileHover={{ scale: 1.05 }}
            >
              <div className="text-xl md:text-2xl lg:text-3xl font-bold text-white mb-1">
                {stat.number}
              </div>
              <div className="text-red-200 text-xs md:text-sm font-medium">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-red-900/50 to-transparent pointer-events-none" />
    </section>
  );
}
